import {FETCH_TWITTER} from '../actions/types';


const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_TWITTER:
            return action.payload;
        default:
            return state;
    }
}